import { BreadcrumbJSONLD } from '~/utils/json-ld/breadcrumb';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableUserOrNull } from '@user/shared/atoms/current-user';
import { FC } from 'react';
import { $PageLevelTraffic } from 'shared/atoms';

export const JsonLD: FC = () => {
  const user = useAtomValue($CurrentAvailableUserOrNull);
  const { canonicalUrl } = useAtomValue($PageLevelTraffic);

  if (!user) {
    return null;
  }

  return (
    <>
      <BreadcrumbJSONLD nameList={['lemon8', user.nickName, 'follow']} path={canonicalUrl}></BreadcrumbJSONLD>
    </>
  );
};
